const STORAGE_KEY_PREFIX = "svetofore.platform-news.read";
const MAX_STORED_NEWS_IDS = 500;
const MAX_NEWS_ID_LENGTH = 120;

export const PLATFORM_NEWS_READ_STATE_CHANGED =
    "platform-news-read-state-changed";

export function getPlatformNewsReadStorageKey(userId) {
    return `${STORAGE_KEY_PREFIX}.${userId}`;
}

function normalizeNewsIds(value) {
    if (!Array.isArray(value)) {
        return [];
    }

    return Array.from(
        new Set(
            value.filter((newsId) => (
                typeof newsId === "string" &&
                newsId.length > 0 &&
                newsId.length <= MAX_NEWS_ID_LENGTH
            ))
        )
    ).slice(-MAX_STORED_NEWS_IDS);
}

export function getReadPlatformNewsIds(userId) {
    if (!userId || typeof window === "undefined") {
        return [];
    }

    try {
        const storedValue = window.localStorage.getItem(
            getPlatformNewsReadStorageKey(userId)
        );

        if (!storedValue) {
            return [];
        }

        const parsedValue = JSON.parse(storedValue);

        return normalizeNewsIds(parsedValue);
    } catch {
        return [];
    }
}

export function markPlatformNewsAsRead(userId, newsId) {
    if (!userId || !newsId || typeof window === "undefined") {
        return;
    }

    const normalizedNewsId = String(newsId);

    if (
        normalizedNewsId.length === 0 ||
        normalizedNewsId.length > MAX_NEWS_ID_LENGTH
    ) {
        return;
    }

    const readNewsIds = getReadPlatformNewsIds(userId);

    if (readNewsIds.includes(normalizedNewsId)) {
        return;
    }

    const nextReadNewsIds = normalizeNewsIds([
        ...readNewsIds,
        normalizedNewsId,
    ]);

    try {
        window.localStorage.setItem(
            getPlatformNewsReadStorageKey(userId),
            JSON.stringify(nextReadNewsIds)
        );

        window.dispatchEvent(
            new CustomEvent(
                PLATFORM_NEWS_READ_STATE_CHANGED,
                {
                    detail: {
                        userId: String(userId),
                    },
                }
            )
        );
    } catch {
        return;
    }
}
